import { useState,useContext } from 'react';
import { useNavigate } from "react-router-dom";
import PropTypes from 'prop-types';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Popover from '@mui/material/Popover';
import DownloadIcon from '@mui/icons-material/Download';
import ShareIcon from '@mui/icons-material/Share';
import LinkIcon from '@mui/icons-material/Link';
import DeleteIcon from '@mui/icons-material/Delete';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import Backdrop from '@mui/material/Backdrop';
import Stack from '@mui/material/Stack';

import EditFileDialog from "../dialog/EditFileDialog.jsx"
import ShareFileDialog from "../dialog/ShareFileDialog.jsx"
import CesiumViewer from "../viewer/CesiumViewer.jsx"
import ShareLinkDialog from "../dialog/ShareLinkDialog.jsx"
import CesiumTokenDialog from "../dialog/CesiumTokenDialog.jsx"
import DeleteFileDialog from "../dialog/DeleteFileDialog.jsx"
import ProductsDialog from "../dialog/ProductsDialog.jsx"
import ErrorViewerDialog from "../dialog/ErrorViewerDialog.jsx"
// import PotreeDialog from '../dialog/potree-dialog.js'

import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

import { AuthContext } from "../context/AuthContext";
import { CloudContext } from "../context/CloudContext";
import {getPresignedURLS3,getPresignedURLForViewer,isViewerReady,isViewerError} from "../utils/interfaceS3";
import { generateShareLink } from "../utils/shareUtils";
import { encodeTransform } from "../viewer/utils/transformationCodec";
import { useCesiumTokens } from "../utils/cesiumTokenUtils";
import { useTranslation } from "react-i18next";
import { useSnackbar } from 'notistack';

export const FilePopover = (props) => {

  const {  t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const navigate = useNavigate();

  const { user, idToken, jwt, service } = useContext(AuthContext);
  const { region, idpool, cesium_token } = useContext(CloudContext);

  const { anchorEl, onClose, open, data, reloadProjects, processings } = props;

  // Check if file is an archive (zip)
  const isArchive = data?.attributes?.filename?.toLowerCase().endsWith('.zip');

  const [isViewerLoading, setIsViewerLoading] = useState(false);
  const [openDialogShareFile, setOpenDialogShareFile] = useState(false);
  const [openDialogEditFile, setOpenDialogEditFile] = useState(false);
  const [openDialogDeleteFile, setOpenDialogDeleteFile] = useState(false);
  const [openDialogProducts, setOpenDialogProducts] = useState(false);
  const [openDialogErrorViewer, setOpenDialogErrorViewer] = useState(false);
  const [openDialogShareLink, setOpenDialogShareLink] = useState(false);
  const [openDialogCesiumToken, setOpenDialogCesiumToken] = useState(false);
  const [shareLink, setShareLink] = useState('');
  const [isGeneratingShareLink, setIsGeneratingShareLink] = useState(false);
  // const [openDialogViewer, setOpenDialogViewer] = useState(false);
  // const [dataViewer, setDataViewer] = useState({});
    // NEW: state for cesium-viewer
    const [showMappingViewer, setShowMappingViewer] = useState(false);
    const [mappingAssetId, setMappingAssetId] = useState(null);
  const [urlLink, setUrlLink] = useState("");

  // Initialize Cesium tokens hook for mapping files
  const cesiumTokens = useCesiumTokens(service === "mapping" && data?.attributes?.mappingAssetId ? data.attributes.mappingAssetId : null);

  async function handleDownloadFileClick () {
    try{
      //console.log(`${data.attributes.filename}`);
      const url = await getPresignedURLS3(user.sub,idToken, region, idpool,`${data.attributes.filename}`,3600);
      window.location.href = url;
    }catch{
      enqueueSnackbar(`${t("errorDownloadFile")}`, {variant:'error'} );
    }
  };

  async function handleShareFileClick() {
    setOpenDialogShareFile(true);
    const url = await getPresignedURLS3(user.sub,idToken, region, idpool,`${data.attributes.filename}`,86400);
    setUrlLink(url);
    onClose();
  };

  const handleDeleteFileClick = num => {
    setOpenDialogDeleteFile(true);
    onClose();
  };

  const handleEditFileClick = num => {
    setOpenDialogEditFile(true);
    onClose();
  };

  const handleProductsClick = num => {
    setOpenDialogProducts(true);
    onClose();
  };

  const handleShareLinkClick = () => {
    setOpenDialogShareLink(true);
    setShareLink(''); // Reset any existing link
    onClose();
  };

  const handleCesiumTokenClick = () => {
    setOpenDialogCesiumToken(true);
    onClose();
  };

  const handleGenerateShareLink = async (expirationHours) => {
    setIsGeneratingShareLink(true);
    try {
      console.log('Generating share link with params:', {
        userSub: user.sub,
        filename: data.attributes.filename,
        expirationHours,
        hasJwt: !!jwt
      });
      
      const link = await generateShareLink(
        user.sub,
        idToken,
        region,
        idpool,
        data.attributes.filename,
        data.attributes.description,
        expirationHours,
        true, // useShortUrl
        jwt   // strapiJwt
      );
      setShareLink(link);
      enqueueSnackbar('Share link generated successfully!', { variant: 'success' });
    } catch (error) {
      console.error('Error generating share link:', error);
      enqueueSnackbar(`Failed to generate share link: ${error.message}`, { variant: 'error' });
    } finally {
      setIsGeneratingShareLink(false);
    }
  };

  async function handleView () {
    if(service==="classic"){
      setIsViewerLoading(true);
      console.log(idToken)
      console.log(region)
      console.log(idpool)
      let viewerReady = await isViewerReady(user.sub,idToken, region, idpool,`${data.attributes.filename}`);
      if(viewerReady){
        const {metadata,hierarchy,octree} = await getPresignedURLForViewer(user.sub,idToken, region, idpool,`${data.attributes.filename}`,86400);
        const filename=data.attributes.filename;
        const description=data.attributes.description;
        setIsViewerLoading(false);
        //setDataViewer({ filename:filename, description:description, metadata:metadata, hierarchy:hierarchy, octree:octree });
        //setOpenDialogViewer(true);
        navigate("/viewer-page/", { state: { filename:filename, description:description, metadata:metadata, hierarchy:hierarchy, octree:octree } });     
      }else{

        let viewererror = await isViewerError(user.sub,idToken, region, idpool,`${data.attributes.filename}`);
        if(viewererror)
        {
          setIsViewerLoading(false);
          setOpenDialogErrorViewer(true);
        }else{
          setIsViewerLoading(false);
          enqueueSnackbar(`${t("ViewerNotReady")}`, {variant:'info'} );
        }
      }
      onClose();
    }
    else if (service === "mapping") {
      // Extract id_cesium from all results
      const resultsIdCesium = data.attributes.results.data
        .map(result => result.attributes.id_cesium)
        .filter(id => id != null); // Filter out null/undefined values

      const pointTransform = data.attributes.transformation_cesium_points?.data;
      const gsTransform    = data.attributes.transformation_cesium_gs?.data;

      // NEW: trigger rendering of CesiumViewer
      navigate("/cesium-viewer-page/", {
        state: {
          mappingAssetId: data.attributes.id_cesium,
          gaussianSplattingId: data.attributes.id_cesium_gs,
          resultsAssetId: resultsIdCesium,
          cesium_token: cesium_token,
          transformationPointsId:  pointTransform?.id ?? null,
          transformationPointsStr: pointTransform ? encodeTransform(pointTransform.attributes) : null,
          transformationGsId:      gsTransform?.id ?? null,
          transformationGsStr:     gsTransform ? encodeTransform(gsTransform.attributes) : null,
        }
      });
      onClose();
    }
  };

  return (
    <>
      <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
      open={isViewerLoading}
      >     
        <Stack
        sx={{
          justifyContent: "flex-start",
          alignItems: "center",
        }}
        direction="row"
        spacing={2}
      >
        <CircularProgress color="inherit" size="5rem"/>
        <Typography variant="h5" color="inherit">
        <b>{t("GettingViewerReady")}</b>
        </Typography>
        </Stack>
      </Backdrop>
      <Popover
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        disableRestoreFocus
        onClose={onClose}
        open={open}
        slotProps={{ paper: { sx: { width: 160 } } }}
      >
        <MenuList
          disablePadding
          dense
          sx={{
            p: '8px',
            '& > *': {
              borderRadius: 1
            }
          }}
        >
          {isArchive ? [
              <MenuItem key="download" onClick={(event) => handleDownloadFileClick(event)}>
                <ListItemIcon>
                  <DownloadIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>{t("Download")}</ListItemText>
              </MenuItem>,
              <MenuItem key="delete" onClick={(event) => handleDeleteFileClick(event)}>
                <ListItemIcon>
                  <DeleteIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>{t("Delete")}</ListItemText>
              </MenuItem>
          ] : [
              <MenuItem key="view" onClick={(event) => handleView(event)}>
                <ListItemIcon>
                  <VisibilityIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>{t("View")}</ListItemText>
              </MenuItem>,
              service==="classic" && <MenuItem key="sharelink" onClick={(event) => handleShareLinkClick(event)}>
                <ListItemIcon>
                  <LinkIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>{t("ShareView")}</ListItemText>
              </MenuItem>,
              service==="mapping" && <MenuItem key="cesiumtoken" onClick={(event) => handleCesiumTokenClick(event)}>
                <ListItemIcon>
                  <LinkIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>{t("ShareView")}</ListItemText>
              </MenuItem>,
              (data.attributes.results.data.length > 0) &&
                <MenuItem key="products" onClick={(event) => handleProductsClick(event)}>
                  <ListItemIcon>
                    <FilePresentIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>{t("Products")}</ListItemText>
                </MenuItem>,
              service==="classic" && <MenuItem key="download" onClick={(event) => handleDownloadFileClick(event)}>
                <ListItemIcon>
                  <DownloadIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>{t("Download")}</ListItemText>
              </MenuItem>,
              service==="classic" && <MenuItem key="share" onClick={(event) => handleShareFileClick(event)}>
                <ListItemIcon>
                  <ShareIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>{t("Share")}</ListItemText>
              </MenuItem>,
              <MenuItem key="edit" onClick={(event) => handleEditFileClick(event)}>
                <ListItemIcon>
                  <EditIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>{t("Edit")}</ListItemText>
              </MenuItem>,
              <MenuItem key="delete" onClick={(event) => handleDeleteFileClick(event)}>
                <ListItemIcon>
                  <DeleteIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>{t("Delete")}</ListItemText>
              </MenuItem>
          ]}
        </MenuList>
      </Popover>
      {/* <PotreeDialog open={openDialogViewer} onClose={setOpenDialogViewer} data={dataViewer}/> */}
      <ErrorViewerDialog open={openDialogErrorViewer} setOpen={setOpenDialogErrorViewer}/>
      <EditFileDialog open={openDialogEditFile} setOpen={setOpenDialogEditFile} data={data} reloadProjects={reloadProjects} processings={processings}/>
      <ShareFileDialog open={openDialogShareFile} setOpen={setOpenDialogShareFile} data={data} url={urlLink}/>
      <ShareLinkDialog 
        open={openDialogShareLink} 
        onClose={() => setOpenDialogShareLink(false)}
        shareUrl={shareLink}
        isGenerating={isGeneratingShareLink}
        onGenerateLink={handleGenerateShareLink}
      />
      <CesiumTokenDialog
        open={openDialogCesiumToken}
        onClose={() => setOpenDialogCesiumToken(false)}
        fileData={data}
        onCreateToken={cesiumTokens.createToken}
        onDeleteToken={cesiumTokens.deleteToken}
      />
      <DeleteFileDialog open={openDialogDeleteFile} setOpen={setOpenDialogDeleteFile} data={data} reloadProjects={reloadProjects} />
      {(data.attributes.results.data.length > 0) && <ProductsDialog products={data.attributes.results.data} open={openDialogProducts} setOpen={setOpenDialogProducts} />}
    
    
      {showMappingViewer && (
        <CesiumViewer id={mappingAssetId} token={cesium_token} />
      )}
    </>
  );
};

FilePopover.propTypes = {
  anchorEl: PropTypes.any,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired
};
